/* * @Author: zxx * @Date: 2020/3/26 * @instraction: 添加新书 */
<template>
  <KllkDrawer v-model="isShowDrawer" class="create-drawer">
    <!-- 按钮 -->
    <div slot="header" class="header-warp">
      <el-button type="primary" class="btns" @click="onSubmit" :loading="isSend">发布</el-button>
      <el-button @click="onSave" class="btns" :loading="isSave">保存</el-button>
      <el-button @click="onCancel" class="btns">取消</el-button>
    </div>
    <!-- 内容 -->
    <el-form
      ref="booksForm"
      label-position="left"
      :model="booksForm"
      :rules="booksRules"
      label-width="90px"
      class="dic-add"
    >
      <el-row type="flex" justify="space-around">
        <el-col :span="12">
          <el-form-item label="序号" prop="sequence">
            <el-input-number
              v-model="booksForm.sequence"
              :min="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="书籍语言" prop="languageType">
            <el-select v-model="booksForm.languageType" placeholder="请选择">
              <el-option
                v-for="item in langList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="24">
          <el-form-item label="书籍名称" prop="bookName">
            <el-input v-model="booksForm.bookName" maxlength="128"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="24">
          <el-form-item label="书籍图片" prop="iconName">
            <el-input
              v-model="booksForm.iconName"
              :readonly="true"
              class="icon-name"
            ></el-input>
            <BookImgs
              @on-add-img="addImg($event)"
              @on-del-img="delImg"
              :bookPicPOList="this.booksForm.bookPicPOList"
              :type="type"
            ></BookImgs>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="24">
          <el-form-item label="书籍简介" prop="description">
            <el-input
              v-model="booksForm.description"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="24">
          <el-form-item label="描述文字" prop="introduction">
            <QuillEditor
              ref="text"
              v-model="booksForm.introduction"
            ></QuillEditor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </KllkDrawer>
</template>
<script>
// 引入组件
import KllkDrawer from "../../components/kllk-drawer";
import QuillEditor from "../../components/kllk-editor";
import BookImgs from "../books/book-imgs";
// api
import {
  PostAddBook,
  PutEditBook,
  GetBookDetail,
  DelBookImg,
} from "../../api/book";
// js
import { langList } from "../../js/code";

export default {
  components: { KllkDrawer, QuillEditor, BookImgs },
  props: {
    value: Boolean,
    bookId: Number,
    type: {
      type: Number,
      default: 0,
    }, //0 添加，1修改
    sequence: Number,
  },
  data() {
    this.order = [
      { key: 1, val: "One" },
      { key: 2, val: "Two" },
      { key: 3, val: "Three" },
      { key: 4, val: "Four" },
      { key: 5, val: "Five" },
    ];
    return {
      langList: langList,
      isShowDrawer: this.value,
      formData: new FormData(),
      booksForm: {
        introduction: "",
        languageType: null,
        bookName: "",
        sequence: null,
        iconName: "",
        description: "",
        bookPicPOList: [],
      },
      booksRules: {
        iconName: [{ required: true, message: "图书封面必填", trigger: "blur" }],
        description: [{ required: true, message: " ", trigger: "blur" }],
        introduction: [{ required: true, message: " ", trigger: "blur" }],
        languageType: [{ required: true, message: " ", trigger: "change" }],
        bookName: [{ required: true, message: " ", trigger: "change" }],
        sequence: [{ required: true, message: " ", trigger: "change" }],
      },
      isSave: false,
      isSend: false
    };
  },
  methods: {
    //   上传图片
    addImg(e) {
      let file = e.file.target.files[0];
      let index = e.index;
      let item = e.item,
        sequence = "";
      // 修改，
      if (item.picId) {
        index = this.booksForm.bookPicPOList[e.index - 1].sequence;
      }
      // 多个文件一个个传，拼成一个数组传不过去，
      let findIndex = this.order.find((val) => val.key === index);
      sequence = findIndex.val;
      // 修改，
      if (item.picId) {
        this.formData.set(
          `imageName`,
          this.booksForm.bookPicPOList[e.index - 1].imageName
        );
        this.formData.set(
          `companyId`,
          this.booksForm.bookPicPOList[e.index - 1].companyId
        );
        this.formData.set(
          `picId${sequence}`,
          this.booksForm.bookPicPOList[e.index - 1].picId
        );
      }
      this.formData.set(`imageFile${sequence}`, file);
      this.formData.set(`sequence${sequence}`, index);
      // 预览图片
      let fileReader = new FileReader();
      let imageUrl;
      let that = this;

      fileReader.readAsDataURL(file);
      fileReader.onload = function(e) {
        imageUrl = e.target.result;
        that.booksForm.bookPicPOList.length = 5;
        that.booksForm.bookPicPOList.splice(index - 1, 0, {
          imageUrl: imageUrl,
          sequence: index,
        });
      };
      // 隐性校验
      if (e.index == 1) {
         this.booksForm.iconName = file.name;
      }
    },
    // 保存
    delImg(e, input) {
      if (!e.picId) {
        input.value = null;
        let findIndex = this.order.find((val) => val.key === e.sequence);
        let sequence = findIndex.val;
        this.formData.delete(`imageFile${sequence}`);
        this.formData.delete(`sequence${sequence}`);
        this.booksForm.bookPicPOList.splice(findIndex.key - 1, 1);
        this.booksForm.iconName = null;
        return false;
      }
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelBookImg(e.picId).then((res) => {
            if (res.status) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.bookId = e.bookId;
              this.booksForm.iconName = null;
              this.GetBookDetail();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 保存
    onSave() {
      this.handleValid(0);
    },
    onSubmit() {
      this.handleValid(1);
    },
    // 校验
    handleValid(num) {
      // 富文本内容
      this.booksForm.introduction = this.$refs.text.$refs.quill.value;
      this.$refs["booksForm"].validate((valid) => {
        if (valid) {
          // form表单提交文件
          this.formData.set("introduction", this.booksForm.introduction);
          this.formData.set("bookName", this.booksForm.bookName);
          this.formData.set("sequence", this.booksForm.sequence);
          this.formData.set("description", this.booksForm.description);
          if (num) {
            this.isSend = true;
            this.formData.set("languageType", this.booksForm.languageType);
            if (this.type) {
              //修改 发布
              this.handleSubmitEdit();
            } else {
              //添加 发布
              this.handleSubmit();
            }
          } else {
            this.isSave = true;
            // 修改
            if (this.type) {
              this.handleEdit();
            } else {
              this.formData.set("languageType", this.booksForm.languageType);
              //添加
              this.handleSave();
            }
          }
        } else {
          this.$notify({
            title: "警告",
            message: "请填写正确信息",
            type: "warning",
          });
        }
      });
    },
    // 修改发布
    handleSubmitEdit() {
      this.formData.set("publish", 1);
      this.formData.set("bookId", this.booksForm.bookId);
      let langtype = langList.find(
        (type) => type.label == this.booksForm.languageType
      );
      this.formData.set("languageType", langtype.value);
      PutEditBook(this.formData).then(res => {
        this.isSend = false;
        if (res.status) {
              this.$notify({
                  title: "成功",
                  message: "发布成功",
                  type: "success"
              });
              this.$emit("on-update");
              this.onCancel();
          }
      }).catch(err => {
        this.isSend = false;
      })
    },
    handleSubmit() {
      this.formData.set("publish", 1);
      PostAddBook(this.formData).then((res) => {
        this.isSend = false;
        if (res.status) {
          this.$notify({
            title: "成功",
            message: "发布成功",
            type: "success",
          });
          this.$emit("on-update");
          this.onCancel();
        }
      }).catch(err => {
        this.isSend = false;
      })
    },
    handleSave() {
      PostAddBook(this.formData).then((res) => {
        this.isSave = false;
        if (res.status) {
          this.$notify({
            title: "成功",
            message: "添加成功",
            type: "success",
          });
          this.$emit("on-update");
          this.onCancel();
        }
      }).catch(err => {
        this.isSave = false;
      })
    },
    handleEdit() {
      this.formData.set("bookId", this.booksForm.bookId);
      let langtype = langList.find(
        (type) => type.label == this.booksForm.languageType
      );
      this.formData.set("languageType", langtype.value);
      PutEditBook(this.formData).then((res) => {
        this.isSave = false;
        if (res.status) {
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
          this.$emit("on-update");
          this.onCancel();
        }
      }).catch(err => {
        this.isSave = false;
      })
    },
    onCancel() {
      this.isShowDrawer = false;
    },
    // 请求单个新书的信息,编辑显示
    GetBookDetail() {
      GetBookDetail(this.bookId).then((res) => {
        if (res.status) {
          let data = res.data;
          let langtype = langList.find(
            (type) => type.value == data.languageType
          );
          this.booksForm = {
            bookName: data.bookName,
            description: data.description,
            bookId: data.bookId,
            sequence: data.sequence,
            introduction: data.introduction,
            languageType: langtype.label,
            bookPicPOList: data.bookPicPOList,
          };
          if (data.bookPicPOList.length > 0) {
            this.booksForm.iconName = data.bookPicPOList[0].imageName
          } else {
            this.booksForm.iconName = null;
          }
        }
      });
    },
  },
  watch: {
    value(n) {
      this.isShowDrawer = n;
    },
    isShowDrawer(n) {
      this.$emit("input", n);
      // 修改，请求单个书籍数据
      if (n && this.type) {
        this.GetBookDetail();
      }
      if (n && !this.type) {
        this.booksForm.sequence = this.sequence;
      }
      // 抽屉关闭，清空数据
      if (!n) {
        this.$refs.booksForm.resetFields();
        this.booksForm.introduction = "";
        this.booksForm.bookPicPOList = [];
        this.formData = new FormData();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.create-drawer {
  .header-warp {
    background: #f5f8fa;
    padding: 16px;

    .btns {
      margin: 0 5px;
    }
  }

  .dic-add {
    padding: 20px;
    .icon-name {
      display: none;
    }
  }
}
</style>
